<template>
    <div
        class="sbs-tab-underline trs"
        :class="underlineClasses"
        :style="underlineStyles"></div>
</template>

<script>
import ResizeObserver from '../../utils/resizeObserver.js';
import themesMixin from '../../mixins/themes.js';
import { converToUnit } from '../../utils/helpers.js';

export default {
    name: 'SbsTabUnderline',
    mixins: [themesMixin],
    data() {
        return {
            isReady: false,
            resizeObserver: null,
            mutationObserver: null,
            mutationObserverConfig: {
                childList: true,
                attributes: true,
                characterData: true,
                subtree: true,
            },
            tabBoundaries: {
                width: null,
                left: null,
            },
        };
    },
    computed: {
        underlineClasses() {
            const classes = [
                ...this.themeClasses,
                {
                    hidden: !this.isReady,
                },
            ];

            if (this.underlineTheme) {
                classes.push(`bg-${this.underlineTheme}`);
            }

            if (this.hoverUnderline && !this.disabled) {
                classes.push(`group-hover-bg-${this.hoverUnderline}`);
            }

            return classes;
        },
        underlineStyles() {
            return {
                width: converToUnit(this.tabBoundaries.width),
                left: converToUnit(this.tabBoundaries.left),
            };
        },
    },
    methods: {
        initObservers() {
            if (!this.tabDomElement) return;

            this.resizeObserver.observe(this.tabDomElement);
            this.mutationObserver.observe(
                this.tabDomElement,
                this.mutationObserverConfig,
            );
        },
        calcBoundaries() {
            const left = this.tabDomElement?.offsetLeft;
            const width = this.tabDomElement?.offsetWidth;

            this.tabBoundaries.left = left;
            this.tabBoundaries.width = width;

            this.isReady = true;
        },
    },
    props: {
        /**
         * DOM элемент таба, для которого отображается нижнее подчеркивание
         */
        tabDomElement: {
            type: [HTMLElement, null],
            default: null,
        },
        /**
         * Тема (цветовые решения) для цвета нижнего подчеркивания при наведении
         */
        hoverUnderline: {
            type: String,
            default: '',
        },
        /**
         * Тема (цветовые решения) для нижнего подчеркивания
         */
        underlineTheme: {
            type: String,
            default: '',
        },
    },
    watch: {
        tabDomElement() {
            this.initObservers();
        },
    },
    created() {
        this.resizeObserver = new ResizeObserver(this.calcBoundaries);
        this.mutationObserver = new MutationObserver(this.calcBoundaries);
    },
    mounted() {
        this.initObservers();
        this.calcBoundaries();
    },
    beforeUnmount() {
        this.resizeObserver.disconnect();
        this.mutationObserver.disconnect();
    },
};
</script>

<style lang="scss">
.sbs-tab-underline {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 4px;
    border-radius: $rounded-pill;

    &.hidden {
        // stylelint-disable-next-line declaration-no-important
        width: 0 !important;
    }
}
</style>
